import React from "react";
import { Card, Button, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Height } from "@mui/icons-material";
import MapContainer from "../Unduh/MapContainer";

const { Meta } = Card;
const gridStyle = {
  width: "25%",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },

          {
            title: "Tools",
          },
        ]}
      />
    }
  >
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="palapa"
            src={
              process.env.PUBLIC_URL + "/static/images/geoportal-palapa.webp"
            }
          />
        }
        actions={[
          //<Link target="_blank" to="https://tanahair.indonesia.go.id/portal-web/palapa">
          <Link to="/tools/palapa">
            <Button type="primary">Lihat Detail</Button>
          </Link>,
        ]}
        title="Palapa"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="palapa"
            src={process.env.PUBLIC_URL + "/static/images/metadata-editor.png"}
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://tanahair.indonesia.go.id/metadata-editor/"
          >
            <Button type="primary">Lihat Detail</Button>
          </Link>,
        ]}
        title="Metadata Editor"
      ></Card>
    </Card.Grid>
    {/*
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="KSP"
            src={process.env.PUBLIC_URL + "/static/images/geoportal-ksp.webp"}
          />
        }
        actions={[
          <Link target="_blank" to="https://onemap.big.go.id/">
            <Button type="primary">Akses</Button>
          </Link>,
        ]}
        title="KSP"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="simojang"
            src={
              process.env.PUBLIC_URL + "/static/images/geoportal-simojang.webp"
            }
          />
        }
        actions={[
          <Link target="_blank" to="https://simojang.big.go.id/">
            <Button type="primary">Akses</Button>
          </Link>,
        ]}
        title="Simojang"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="petakita"
            src={
              process.env.PUBLIC_URL + "/static/images/geoportal-petakita.webp"
            }
          />
        }
        actions={[
          <Link target="_blank" to="https://petakitav3.big.go.id/">
            <Button type="primary">Akses</Button>
          </Link>,
        ]}
        title="Peta Kita"
      ></Card>

    </Card.Grid>
    */}
  </Card>
);
export default App;
